import React from 'react';
import { SvgIcon } from '@mui/material';

const ChatCircleIcon = React.forwardRef((props, ref) => {
	const { sx, ...other } = props;
	
	return (
		<SvgIcon
			ref={ref}
			viewBox="0 0 16 16"
			sx={sx}
			{...other}
		>
			<path 
				d="M8 14C9.18669 14 10.3467 13.6481 11.3334 12.9888C12.3201 12.3295 13.0892 11.3925 13.5433 10.2961C13.9974 9.19975 14.1162 7.99335 13.8847 6.82946C13.6532 5.66558 13.0818 4.59648 12.2426 3.75736C11.4035 2.91825 10.3344 2.3468 9.17054 2.11529C8.00666 1.88378 6.80026 2.0026 5.7039 2.45673C4.60754 2.91085 3.67047 3.67989 3.01118 4.66658C2.35189 5.65328 2 6.81331 2 8C2 8.96 2.22533 9.86667 2.62667 10.6713C2.92867 11.2787 2.50867 12.098 2.34867 12.696C2.31322 12.8283 2.31321 12.9675 2.34865 13.0998C2.38408 13.232 2.45371 13.3526 2.55053 13.4495C2.64736 13.5463 2.76796 13.6159 2.90022 13.6514C3.03248 13.6868 3.17174 13.6868 3.304 13.6513C3.902 13.4913 4.72133 13.0713 5.32867 13.374C6.15881 13.7862 7.07316 14.0005 8 14Z" 
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
});

ChatCircleIcon.displayName = 'ChatCircleIcon';

export default ChatCircleIcon;
